module.exports = __webpack_public_path__ + "static/img/fenzuhanhua2.77dbda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/fenzuhanhua2.png
// module id = vnMc
// module chunks = 24